import { Modal } from '@cloudscape-design/components';
import LoadingSpinner from 'src/components/LoadingSpinner';
import React, { useEffect } from 'react';
import { useApi } from 'src/hooks/useApi';
import { useRenderContent } from 'src/components/ArtifactDetail/components/useRenderContent';

interface ArtifactDetailModalProps {
    modalHref: string;
    setModalHref: (href: string) => void;
    latestId: number;
    latestLcmsXmlID: number;
    artifactId: string;
}

export const ArtifactDetailModal = ({
    modalHref,
    setModalHref,
    artifactId,
    latestId,
    latestLcmsXmlID,
}: ArtifactDetailModalProps) => {
    const baseDynamicURL = `https://core-ar.bravais.com/api/dynamic/documentVersions/${latestId}/contentObjects/${latestLcmsXmlID}/`;
    const { makeRequest, data, error, loading } = useApi({
        method: 'GET',
    });
    useEffect(() => {
        if (modalHref.length) {
            const url = `learning-artifacts/xref/${latestId}/${latestLcmsXmlID}/${encodeURI(
                modalHref
            )}`;
            makeRequest({ url });
        }
    }, [modalHref]);

    const { artifactHtml } = useRenderContent({
        artifactId,
        baseDynamicURL,
        data,
        loading,
        setModalHref,
    });
    return (
        <Modal
            visible={!!modalHref.length}
            onDismiss={() => {
                setModalHref('');
            }}
            size={'large'}
        >
            {loading ? (
                <LoadingSpinner />
            ) : (
                <object className={'xyleme-container'}>{artifactHtml}</object>
            )}
        </Modal>
    );
};
